module.exports = __webpack_public_path__ + "static/media/header5.e668e86a.gif";